<!-- Contact Section Start -->
<div class="el-contact-wrapper p-0">
    <div class="container">
        <div class="el-contact-flex pt--4">
            <div class="col-lg-5">
                <div class="el-contact-left-flex">
                    <div class="el-contact-left-image">
                        <img src="../assets/images/all-instructor/contact-image.png" alt="Image"
                            class="el-contact-image" />
                    </div>
                    <div class="el-contact-form-box" style="min-width: 100%">
                        <img src="../assets/images/all-instructor/star-smile.png" alt="star" class="el-star-smile" />

                        <form [formGroup]="object" (ngSubmit)="login()" *ngIf="step == 'login'">
                            <div class="el-contact-form-head">
                                <h4>Sign In Here!</h4>
                                <p class="el-para">Get details in your inbox right now</p>
                            </div>
                            <div class="row" *ngIf="!isEmailLoginMode">
                                <div class="el-input-field col-12" (click)="LoginWithSocialMedia('Google')">
                                    <a class="el-btn btn-default googlelogin py-3" style=""><svg aria-hidden="true"
                                            class="native svg-icon iconGoogle" width="25" height="25"
                                            viewBox="0 0 18 18">
                                            <path fill="#4285F4"
                                                d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18">
                                            </path>
                                            <path fill="#34A853"
                                                d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17">
                                            </path>
                                            <path fill="#FBBC05"
                                                d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18z"></path>
                                            <path fill="#EA4335"
                                                d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.8 4.8 0 0 1 4.48-3.3">
                                            </path>
                                        </svg>&nbsp; Sign in using Google</a>
                                </div>
                                <div class="el-input-field col-12" (click)="LoginWithSocialMedia('Facebook')">
                                    <a class="el-btn btn-default facebooklogin py-3"><svg width="25" height="25"
                                            viewBox="0 0 8 14">
                                            <path path fill="#4285F4"
                                                d="M4.61903 13.1094V7.13001H6.71611L7.03074 4.79906H4.61903V3.31108C4.61903 2.63643 4.81405 2.17666 5.82647 2.17666L7.11562 2.17615V0.0912609C6.89268 0.0635446 6.1274 0 5.2367 0C3.37678 0 2.10344 1.08609 2.10344 3.08022V4.79906H0V7.13001H2.10344V13.1094H4.61903Z">
                                            </path>
                                        </svg>&nbsp; Sign in using Facebook</a>
                                </div>
                                <div class="el-input-field col-12" (click)="LoginWithSocialMedia('Email')">
                                    <a class="el-btn btn-default emaillogin py-3"><i class="fas fa-envelope"></i>&nbsp;
                                        Sign in with Email</a>
                                </div>
                            </div>
                            <div *ngIf="isEmailLoginMode">
                                <div class="text-end my-2">
                                    <a class=" " (click)="isEmailLoginMode = false">
                                        <i aria-hidden="true" class="fa fa-reply color-theme">
                                            Back</i>
                                        <!-- <i class='bx bx-x'>close</i> -->
                                    </a>
                                </div>
                                <div class="el-input-field">
                                    <input type="text" placeholder="Email ID" formControlName="emailId" [ngClass]="{
                      'input-error':
                        _form.emailId.invalid &&
                        (_form.emailId.touched || _form.emailId.dirty)
                    }" />
                                    <!-- <div *ngIf="_form.emailId.invalid && (_form.emailId.dirty || _form.emailId.touched)"
                                        class="error">
                                        <div *ngIf="_form.emailId.invalid && (_form.emailId.dirty || _form.emailId.touched)"
                                            class="error">
                                            <div *ngIf="_form.emailId.errors.required"> Email-Id is required </div>
                                            <div *ngIf="_form.emailId.errors.email"> Invalid email-Id.</div>
                                        </div>

                                    </div> -->
                                </div>

                                <div class="el-input-field" style="position: relative">
                                    <input [type]="showPassword ? 'password' : 'text'" placeholder="Password"
                                        formControlName="password" [ngClass]="{
                      'input-error':
                        _form.password.invalid &&
                        (_form.password.touched || _form.password.dirty)
                    }" style="padding-right: 35px" />
                                    <span (click)="togglePasswordVisibility()" style="
                      position: absolute;
                      right: 10px;
                      top: 50%;
                      transform: translateY(-50%);
                      cursor: pointer;
                    ">
                                        <i class="fa" [class.fa-eye]="!showPassword"
                                            [class.fa-eye-slash]="showPassword"></i>
                                    </span>
                                </div>

                                <!-- <div *ngIf="_form.password.invalid && (_form.password.dirty || _form.password.touched)"
                                        class="error">
                                        <div *ngIf="_form.password.errors?.required"> Password is required</div>
                                        <div *ngIf="_form.password.errors?.minlength"> Password must be at least {{
                                            _form.password.errors.minlength.requiredLength }} characters</div>
                                    </div> -->
                                <div class="el-input-field">
                                    <div class="row">
                                        <div class="col-4 col-center">
                                            <button type="Submit" [disabled]="object.invalid"
                                                class="el-btn loginbtn w-100">
                                                Sign In
                                            </button>
                                        </div>

                                        <div class="col-8 col-center">
                                            <div class="text-end">
                                                <a class="text-primary" style="cursor: pointer"
                                                    (click)="changeStep('forgot')">Forgot Password?</a>
                                            </div>
                                        </div>
                                        <div class="pt-5 pb-0">
                                            <div class="d-flex justify-content-center align-items-center pb-2">
                                                <div>
                                                    <a class="text-primary" style="cursor: pointer"
                                                        (click)="changeStep('register')">Don't have an account? Register
                                                        now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <form [formGroup]="object" (ngSubmit)="RegisterForm()" *ngIf="step == 'register'">
                            <div class="el-contact-form-head">
                                <h4>Sign Up Here!</h4>
                                <p class="el-para">Get details in your inbox right now</p>
                            </div>
                            <!-- sign-up section-->

                            <div class="el-input-field" *ngIf="otpEmailStatus == false && OTPStatus == false">
                                <input type="text" placeholder="Email ID" formControlName="emailId" [ngClass]="{
                    'input-error':
                      _form.emailId.invalid &&
                      (_form.emailId.touched || _form.emailId.dirty)
                  }" />

                                <div *ngIf="
                    _form.emailId.invalid &&
                    (_form.emailId.dirty || _form.emailId.touched)
                  " class="error">
                                    <div *ngIf="_form.emailId.errors?.required">
                                        Email-Id is required
                                    </div>
                                    <div *ngIf="_form.emailId.errors?.email">
                                        Invalid email-Id.
                                    </div>
                                </div>
                            </div>

                            <div class="el-input-field">
                                <div class="row">
                                    <div class="d-flex justify-content-between"
                                        *ngIf="otpEmailStatus == false && OTPStatus == false">
                                        <div class="col-lg-5 mb-3">
                                            <button type="button" class="el-btn loginbtn" style="width: 100%"
                                                (click)="changeStep('login')">
                                                <i aria-hidden="true" class="fa fa-reply"> </i>&nbsp;Back
                                            </button>
                                            <!-- <a class="el-btn" style="width: 100%;">Send OTP</a> -->
                                        </div>
                                        <div class="col-lg-5 mb-3">
                                            <button type="button" class="el-btn loginbtn" style="width: 100%"
                                                [disabled]="_form.emailId.invalid"
                                                (click)="sendOTP(this.object.value.emailId)">
                                                Next &nbsp;<i class="fas fa-fast-forward"></i>
                                            </button>
                                            <!-- <a class="el-btn" style="width: 100%;">Send OTP</a> -->
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="otpEmailStatus == false && OTPStatus == true">
                                        <label>
                                            Email: <strong>{{ this.object.value.emailId }}</strong>
                                        </label>
                                        <div class="col-sm-8 mt-2">
                                            <div class="el-nesltr-right">
                                                <div class="el-input-field">
                                                    <input type="number" placeholder="Your Otp " #VerifyOtp required />
                                                    <a href="javascript:;" class="el-btn"
                                                        (click)="VeriFyEmailOtp(VerifyOtp.value)">Verify OTP</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 mb-3 mt-2">
                                            <button class="el-btn loginbtn" [disabled]="ResendOTPButton"
                                                (click)="sendOTP(object.value.emailId)">
                                                Re-Send OTP
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="error" *ngIf="otpEmailStatus == true && OTPStatus == false">
                                <label style="font-size: 20px">Email:
                                    <strong>{{ this.object.value.emailId }}</strong></label>

                                <div class="el-input-field mt-5">
                                    <input type="text" placeholder="Full Name" formControlName="name" [ngClass]="{
                      'input-error':
                        _form.name.invalid &&
                        (_form.name.touched || _form.name.dirty)
                    }" />
                                    <div *ngIf="
                      _form.name.invalid &&
                      (_form.name.dirty || _form.name.touched)
                    " class="error">
                                        <div *ngIf="_form.name.errors?.required">
                                            Name is required
                                        </div>
                                        <div *ngIf="_form.name.errors?.minlength">
                                            Name must be at least
                                            {{ _form.name.errors.minlength.requiredLength }}
                                            characters
                                        </div>
                                    </div>
                                </div>
                                <div class="el-input-field">
                                    <input type="text" placeholder="Mobile Number" formControlName="MobileNumber"
                                        [ngClass]="{
                      'input-error':
                        _form.MobileNumber.invalid &&
                        (_form.MobileNumber.touched || _form.MobileNumber.dirty)
                    }" />
                                    <div *ngIf="
                      _form.MobileNumber.invalid &&
                      (_form.MobileNumber.dirty || _form.MobileNumber.touched)
                    " class="error">
                                        <div *ngIf="_form.MobileNumber.errors?.required">
                                            Mobile Number is required
                                        </div>
                                        <div *ngIf="_form.MobileNumber.errors?.pattern">
                                            Mobile Number must be 10 digits
                                        </div>
                                    </div>
                                </div>
                                <div class="el-input-field">
                                    <input type="password" placeholder="Password" formControlName="Password"
                                        [ngClass]="{'input-error':_form.Password.invalid && (_form.Password.touched || _form.Password.dirty)}" />
                                    <div *ngIf=" _form.Password.invalid &&(_form.Password.dirty || _form.Password.touched)"
                                        class="error">
                                        <div *ngIf="_form.Password.errors?.required">
                                            Password is required
                                        </div>
                                        <div *ngIf="_form.Password.errors?.minlength">
                                            Password must be at least
                                            {{ _form.Password.errors.minlength.requiredLength }}
                                            characters
                                        </div>
                                    </div>

                                </div>
                                <div class="el-input-field">
                                    <input type="password" placeholder="confirm Password"
                                        formControlName="confirmpassword" [ngClass]="{
                      'input-error':
                        _form.confirmpassword.invalid &&
                        (_form.confirmpassword.touched ||
                          _form.confirmpassword.dirty)
                    }" />
                                    <div *ngIf="
                      _form.confirmpassword.invalid &&
                      (_form.confirmpassword.dirty ||
                        _form.confirmpassword.touched)
                    " class="error">
                                        <div *ngIf="_form.confirmpassword.errors?.required">
                                            Confirm Password is required
                                        </div>
                                        <div *ngIf="_form.confirmpassword.errors?.minlength">
                                            Confirm Password must be at least
                                            {{
                                            _form.confirmpassword.errors.minlength.requiredLength
                                            }}
                                            characters
                                        </div>
                                    </div>
                                    <!-- Passwords mismatch error (form-level) -->
                                    <div *ngIf="
                      object.errors?.passwordsMismatch &&
                      (_form.confirmpassword.dirty ||
                        _form.confirmpassword.touched)
                    " class="error">
                                        Passwords do not match
                                    </div>

                                </div>

                                <div class="el-input-field">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <button type="Submit" [disabled]="object.invalid" class="el-btn">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="el-contact-form-btn">
                            <a href="javascript:;" class="el-btn">Submit</a>
                        </div> -->
                            </div>
                        </form>
                        <div class="row">
                            <form [formGroup]="object" (ngSubmit)="onForgotPassword()" *ngIf="step == 'forgot'">
                                <div class="el-contact-form-head">
                                    <h4>Forgot Password</h4>
                                    <p class="el-para">
                                        Enter your email address to receive your password via email
                                    </p>
                                </div>
                                <div class="el-input-field">
                                    <input type="text" placeholder="Email ID" formControlName="emailId" [ngClass]="{
                      'input-error':
                        object.get('emailId').invalid &&
                        (object.get('emailId').touched ||
                          object.get('emailId').dirty)
                    }" />
                                    <!-- <div *ngIf="object.get('emailId').invalid && (object.get('emailId').dirty || object.get('emailId').touched)"
                                        class="error">
                                        <div *ngIf="object.get('emailId').errors?.required">Email-Id is required</div>
                                        <div *ngIf="object.get('emailId').errors?.email">Invalid email-Id.</div>
                                    </div> -->
                                </div>
                                <div class="el-input-field">
                                    <button type="submit" [disabled]="object.invalid" class="el-btn">
                                        Recover Password
                                    </button>
                                    <a class="text-primary" style="cursor: pointer; margin-left: 10px"
                                        (click)="changeStep('login')">Back to Login</a>
                                </div>
                            </form>
                        </div>

                        <div class="row" *ngIf="step == 'SuccessNewReg'">
                            <div class="el-contact-form-head text-center">
                                <i class="fa fa-check-circle" aria-hidden="true"
                                    style="color: green; font-size: 30px"></i>
                                <h4 style="color: green">Registration successful.</h4>
                                <p>
                                    <small>Your email and password have been sent to your registered
                                        email address.</small>
                                </p>
                                <a class="el-btn" style="cursor: pointer; margin-top: 50px" (click)="BackToLogin()">Back
                                    to Login</a>
                            </div>
                        </div>
                        <img src="../assets/images/all-instructor/dasboard-pencel.png" alt="" class="pencel" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Contact Section End -->